import React from 'react';

import { bemCssModules, getTestId } from '@utils';

import { useStore } from '@modules';

import style from './ZHDisclaimer.scss';

const cn = bemCssModules(style, 'ZHDisclaimer');
const ti = getTestId('ZHDisclaimer');

export const ZHDisclaimer: CustomFC = ({ className }) => {
  const [{ operationBlock }] = useStore();

  if (operationBlock.consentRequired !== 'zh') return null;
  return (
    <div className={cn(null, [className, 'small'])} data-testid={ti()}>
      Cryptocurrency services <br className={cn('wrap')} />
      provided by ZeroHash
    </div>
  );
};

export default ZHDisclaimer;
